import React, { useState, useEffect } from "react";
import { AdminLogin } from "../../Api/Admin/authServices"
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AdminLoginPage = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: "admin@gmail.com",
        password: "Admin@1234",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        if (!formData.email || !formData.password) {
            setError("All fields are required.");
            return;
        }
        setLoading(true);

        try {
            const res = await AdminLogin(formData);
            console.log(res);
            if (res.status == 200) {
                localStorage.setItem("token", res.data.token);
                localStorage.setItem("Role", res.data.admin.role);
                navigate("/admin")
            }
            setFormData({ email: "", password: "" });
        } catch (err) {
            console.error(err);
            setError(err.response.data.message);
        }
        setLoading(false)
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-lg bg-white shadow-lg p-8">
                {/* Modal Content */}
                <h2 className="text-xl font-bold text-center mb-6">Login</h2>

                <form onSubmit={handleSubmit} className="w-full p-4">
                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaEnvelope className="text-gray-500" />
                            </span>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    <div className="mb-6">
                        <div className="relative">
                            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                <FaLock className="text-gray-500" />
                            </span>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                placeholder="Password"
                                className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                            />
                        </div>
                    </div>

                    {error && (
                        <div className="mb-4 text-red-500 text-sm">
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        className="w-full bg-black text-white py-3 rounded-md shadow-md hover:bg-gray-900 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    >
                        {loading ? "Loading..." : "Login"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLoginPage;
